export const ToastSuccess = (success) => {
    if (success) {
        return success === 'CONTACT_US' ? 'Message was sent' :
           success === 'CHANGE_PASSWORD_REQUEST' ? 'Password was changed'
                            : false;
    }
};
